import React from "react";
import AephoriaTable from '../comps/aephoriaTable';
import * as aserver from '../../APIClient';
import Modal from '../comps/modal';
import Button from '@material-ui/core/Button';
import { withRouter } from "react-router";
import { withStyles } from '@material-ui/core/styles';
import Toast from "../comps/alertMessage";
import LoadingBackdrop from '../comps/loadingBackdrop';
import AlertModal from "../comps/alertModal";
import { getTeamReportDownloadLinks } from "../../Utilities";
import * as utils from "../../Utilities";
import copyIcon from '../images/Duplicate.png'
import addIcon from '../images/User add.png'
import viewIcon from '../images/Search circle.png'
import editIcon from '../images/Pencil.png'
import deleteIcon from '../images/Trash.png'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import {isMobile} from 'react-device-detect';
import deleteIconBlue from '../images/Trash-blue.png'
import downloadIcon from '../images/Download.png'


const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
});

 class Teams extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
          coachId: localStorage.getItem('Id'),
          modalIsOpen: false,
          openModal:false,
          reportType: "",
          name:"",
          description:"",
          projectName:"",
          teamsId:"",
          teamsModalSubmitCaption:"X",
          teamsModalSubmitFunction: this.addTeams,
          teamsModalTitle: "X",
          allClientsData:[],
          teamId:"",
          teamUUID: "",
          level:"",
          message:"",
          displayedNumberOfRecordsSelected:0,
          dueDate: "",
          minDate: "",
          hasMaturityAccreditation: localStorage.getItem("hasMaturityAccreditation") === "1",
          alertModalTitle: "",
          alertMessage:"",
          openAlertModal: false,
          confirmationFunction: this.confirmationFunction,
          confirmationModal: false,
          reportRequested: "",
          duplicateModal:false,
          newTeamName:"",
          openBackdrop: false,
          selectedAssessmentUUIDs:[],
          selected_UUIDs:[],
          uniqueCoachlist: [],
          assignSCOModalOpen:false,
          revokeSCOModal:false,
          secondaryCoachEmailAddress: "",
          invalidEmailAddress: true,
          showInvalidEmailAddressText: false,
          };
      }

      selectedData =(numberOfRecordsSelected)=>{
       this.setState({
         displayedNumberOfRecordsSelected: numberOfRecordsSelected,
       })
      }

      massageData = (data) => {
        this.setState({
          allClientsData: data
        })

        let scoReceivedFromExists = false;
        let scoGivenToExists = false;

        for (let record of data){
          aserver.convertUTCToLocal(record, 'createdAt');
          aserver.convertUTCToLocal(record, 'reportSuppliedAt');
          aserver.convertUTCToLocal(record, 'reportDueDate', true); 
          record.reportSuppliedAt = getTeamReportDownloadLinks(this, record, aserver);

          record.SCOReceived = record.scoReceivedFrom && record.scoReceivedFrom.name 
          ? record.scoReceivedFrom.name 
          : '';

          record.SCOGiven = record.scoGivenTo && record.scoGivenTo.length
          ? (
              <span style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {record.scoGivenTo.map((coach, index) => (
                      <span key={index} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          {`${coach.name} ${coach.surname}`}
                          <img
                              src={deleteIconBlue}
                              style={{ cursor: 'pointer', width: "18px" }}
                              onClick={() => this.openRevokeModal(record, coach)}
                              alt="Delete"
                          />
                      </span>
                  ))}
              </span>
          )
          : '';

          if ( record.SCOGiven !== 'N/A') {
            scoGivenToExists = true;
          }
 
          if(record.SCOReceived !== 'N/A'){
            scoReceivedFromExists = true
          }

        }
        this.setState({
          scoGivenToExist: scoGivenToExists,
          scoReceivedFromExist: scoReceivedFromExists
        });
      }

      showToast = () => {
        this.setState(
          {
            showToast: true
          },
          () => {
            setTimeout(() => this.setState({ showToast: false }), 2000);
          }
        );
      }

      refreshTable=()=>{
        window.location.reload(false)
        this.closeModal()
      }


      toastMessage = (text, level) =>{
        this.setState({
          message:text,
          level: level
        })
        this.showToast()
      }

      openAlertModal=(title, message)=>{
        this.closeModal()
        this.setState({
          alertModalTitle: title,
          alertMessage: message,
          openAlertModal: true,
        })
      }

      closeModal = () => {
        this.setState({
          modalIsOpen: false,
          openModal:false,
          openAlertModal: false,
          confirmationModal: false,
          duplicateModal:false,
          assignSCOModalOpen:false,
          revokeSCOModal:false,
          isReportAvailable: false,
        });
      }

      escFunction =(event)=>{
        if(event.keyCode === 27) {
         this.closeModal()
        }
      }

      blankCoach = () => {
        this.setState({
          name: '',
          description: '',
         });
      }

      handleChange = ({ target: { name, value, type } }) => {
        let invalidEmailAddress = this.state.invalidEmailAddress;
        if (type === "email") {
          invalidEmailAddress = !utils.validateEmail(value);
        }
        this.setState({
          [name]: value,
          invalidEmailAddress,
          showInvalidEmailAddressText: invalidEmailAddress,
        });
      }

      handleAdd = ()  => {
        this.blankCoach();
        this.setState({
          teamsModalTitle: 'Add Team',
          teamsModalSubmitFunction: this.addTeams,
          teamsModalSubmitCaption: 'Add Team',
          modalIsOpen: true,
        });
      }

      addTeams = async (event) => {
        event.preventDefault();
        const { name, description, coachId, projectName} = this.state;
        if(name.length > 0 && projectName.length > 0){
          let team = await aserver.post(`api/v2/coaches/${coachId}/teams`,
          {
            name: name,
            description:description,
            coach:projectName
          });
          if (team.status === 200){
          this.refreshTable()
          }
          else {
          this.openAlertModal("Failed", team.data.error.info)
          }
        }else{
          this.toastMessage("Please enter a team name and a project name.", "danger")
        }

      }

      checkTeamConditions = (result, action) => {
        this.setState({
          isReportAvailable: result.isReportAvailable
        })
        if (result.scoReceivedFrom) {
            const message = !result.isReportAvailable
                ? `This team has been given to you - you cannot ${action} it. You can only download the team reports, when they become available.`
                : `This team has been given to you - you cannot ${action} it. You can only download the team reports.`;
            
            this.openAlertModal("Failed", message);
            return false;
        }else{
          return true
        }
    };

      handleView = (selectedRecord,b,c,d,e,selectedTeamId) => {
        const result = this.state.allClientsData.find(({ id }) => id === +selectedTeamId);
        if (!this.checkTeamConditions(result, "view")) {
          return;
      }        
        
      this.fetchTeam(selectedTeamId);
        aserver.goto('/coachportal/team');
        localStorage.setItem("teamID", selectedRecord );
      }

      handleEdit = (selectedRecord ,b, c,d,e, selectedTeamId) => {
        const result = this.state.allClientsData.find(({ id }) => id === +selectedTeamId);
        if (!this.checkTeamConditions(result, "edit")) {
          return;
        }       
        this.fetchTeam(selectedTeamId);
        this.setState({
          teamsModalTitle: 'Edit Team',
          teamsModalSubmitFunction: this.saveChanges,
          teamsModalSubmitCaption: 'Save Changes',
          modalIsOpen:true,
          teamUUID: selectedRecord,
          teamId: selectedTeamId,
        });
      }

      openDuplicateModal = (selectedRecord ,b, c,d,e, selectedTeamId)=>{
        const result = this.state.allClientsData.find(({ id }) => id === +selectedTeamId);
        if (!this.checkTeamConditions(result, "duplicate")) {
          return;
      }        
      if(!result.isReportAvailable){
          this.openAlertModal("Please Note", "A team report must be requested before you can duplicate this team.")
          return
        }
        this.fetchTeam(selectedTeamId)
        this.setState({
          duplicateModal:true,
          teamUUID: selectedRecord,
        })
      }

      handleDuplicate = async () => {
        try {
          await aserver.post(`api/v2/teams/${this.state.teamUUID}/duplicate`, {
            newTeamName: this.state.newTeamName,
          });
          this.refreshTable(); // does a reload of page, would be smoother if it just added the new team into the table.       
        } catch (err) {
          this.openAlertModal("Failed", "Duplicate team failed.")
        }
      }

      fetchTeam = (selectedTeamId) => {
        let date = new Date();
        let options = {year: 'numeric', month: 'long'};
        let currentDate = date.toLocaleString('en-ZA', options)
        let num = +selectedTeamId.join("");
        const result = this.state.allClientsData.find( ({ id }) => id === num );
        this.setState({
          name: result.name,
          description: result.description,
          projectName: result.coach,
          numberOfMembers: result.memberCount,
          newTeamName:result.name+" "+currentDate
        });
        localStorage.setItem("Team-Name", result.name)
      }

      saveChanges = async() => {
        const {teamUUID, name, description, allClientsData, teamId, projectName} = this.state;
        let teams =  await aserver.put(`api/v2/teams/${teamUUID}`,
        {
          name: name,
          description:description,
          coach: projectName
        });
        let clientId = +teamId.join("");
        let newObject = allClientsData.findIndex((obj => obj.id === clientId))
        allClientsData[newObject].name = name;
        allClientsData[newObject].description = description;
        allClientsData[newObject].coach = projectName;
        if (teams.status === 200) {
          this.closeModal()
         }
        else{
         this.openAlertModal("Failed", teams.data.error.info)
        }
      }

      addTeamMembers=()=>{
        aserver.goto('/coachportal/assessments');      
      }

      onChangeValue =(event)=> {
        this.setState({reportType: event.target.value})
      }

      changeDate= (event) =>{
        this.setState({
          dueDate: event.target.value
        });
      }

      cancelTeamReport = async(selectedRecord)=>{
        let cancel = await aserver.get(`api/v2/teams/${selectedRecord}/cancelReportRequest`);
        if(cancel.status === 200){
          this.refreshTable()
        }
        else{
          this.openAlertModal("Failed",cancel.data.error.info)
        }

      }

      downloadSummary=async(selectedRecord)=>{
        let downloadSummary = await aserver.download(`api/v2/teams/${selectedRecord}/downloadSummary`)
        if(downloadSummary.status === 200){
          this.toastMessage("Downloading...", "success")
        }else{
          this.openAlertModal("Failed", "Failed")
        }
      }


      previousDateRemoved=()=>{
        var today = new Date();
        var dd = String(today.getDate() + 1).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;

        this.setState({
          minDate: today
        })
      }

      hasRecordFromAnotherCoachCheck = (uuids)=>{
        for (let UUID of uuids) {
          let client = this.state.allClientsData.find(({ uuid }) => uuid === UUID);
          if (client && client.scoReceivedFrom) {
            this.openAlertModal("Please Note", "Your selection includes teams that were given to you by another coach. Please amend your selection and try again.")
            return true; 
          }
        }
        return false; 
      }

      componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
        if(localStorage.getItem("ReRoute")){
          this.handleAdd();
          localStorage.removeItem("ReRoute")
        }
        if(!this.state.hasMaturityAccreditation){
          this.setState({
            reportType:"Ennea"
          })
        }
      }

      openWrapUpModal = (uuids) => {
        let hasWrapped = false;
        let hasUnwrapped = false;

        for (let uuid of uuids) {
          let checkedIfWrapped = this.state.allClientsData.find(({ uuid: recordUuid }) => recordUuid === uuid);
          if (checkedIfWrapped.coachWrappedUp) {
            hasWrapped = true;
          } else {
            hasUnwrapped = true;
          }
        }

        if (hasWrapped && hasUnwrapped) {
          this.openAlertModal("Warning", "The selection contains both previously wrapped up and unwrapped up teams. Please change the selection to include only all wrapped up or all unwrapped up teams.");
          return;
        }

        const confirmationMessage = hasUnwrapped ?
          "The selected team(s) will be marked as wrapped up, which means they will be greyed out." :
          "The selected team(s) will no longer be marked as wrapped up, which means they will no longer be greyed out.";

        this.setState({
          confirmationModal: true,
          confirmationModalText: confirmationMessage,
          confirmationHeading: "Confirmation",
          confirmationFunction: () => this.wrapUpAssessment(uuids),
        });
      }

      wrapUpAssessment = async (uuids) => {
        if (this.hasRecordFromAnotherCoachCheck(uuids))
          return;
        const { allClientsData } = this.state;
        let failureMessages = [];
        let successCount = 0;
        for (let uuid of uuids) {
          let checkedIfWrapped = allClientsData.find(({ uuid: recordUuid }) => recordUuid === uuid);
          let wrap = await aserver.put(`api/v2/teams/${uuid}`, {
            coachWrappedUp: checkedIfWrapped.coachWrappedUp === 1 ? false : true
          });
          if (wrap.status !== 200) {
            failureMessages.push(`${checkedIfWrapped.name} wrap up failed.`);
          } else {
            successCount++;
          }
        }
        if (failureMessages.length > 0) {
          this.openAlertModal("Failed", failureMessages.join(' '));
        }
        if (successCount > 0) {
          this.refreshTable()
        }
      }

      openAssignSCOModal=(selectedAssessmentUUIDs)=>{
        if (this.hasRecordFromAnotherCoachCheck(selectedAssessmentUUIDs))
              return;
              this.setState({
                assignSCOModalOpen:true,
                selectedAssessmentUUIDs: selectedAssessmentUUIDs,
              })
      }

      assignTeamSCO =async()=>{
        this.setState({assignSCOModalOpen:false})
        let scoResult = await aserver.post(`api/v2/coaches/${this.state.coachId}/assignTeamSCO`, {
          secondaryCoachEmailAddress: this.state.secondaryCoachEmailAddress,
          teamUUIDs: this.state.selectedAssessmentUUIDs
        })
        if (scoResult.data.success) {
          this.toastMessage("Success", "success")
          this.refreshTable();
        } else {
          this.openAlertModal("Please Note", "That email address is not associated with a coach registered on the Aephoria system");
        }
      }

    openRevokeModal=(record, coach)=>{
      this.setState({
        revokeSCOModalTitle: 'Revoke SCO ',
        revokeModalSubmitFunction: () => this.revokeTeamSCO(record,coach),
        revokeSCOModal:true,
        revokeMessage: `Take back this team ${record.name} from coach ${coach.name + " " + coach.surname }?`,
      });
    }

    revokeTeamSCO = async (record, coach) => {
      const records = [
        {
            uuid: record.uuid,
            coachUUID: coach.uuid
        }
    ];
      let scoResult = await aserver.post(`api/v2/coaches/${this.state.coachId}/revokeTeamSCO`, {
        records: records
      });
    
      if (scoResult.data.success) {
        this.refreshTable();
      } else {
        this.openAlertModal("Failed", `SCO revoking failed: ${scoResult.data.error}`)
      }
    };


      componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
      }

     render(){
        const classes = this.props.classes;
        let showAllColumnsDesktop = [
          {dataField: "name", caption: "Name"},
          {dataField: "description", caption: "Description"},
          {dataField: "coach", caption: "Project"},
          {dataField: "memberCount", caption: "Number of Members"},
          {dataField: "createdAt", caption: "Created"},
          {dataField: "reportRequestedDisplay", caption: "Report Requested"},
          {dataField: "reportDueDate", caption: "Due Date"}, 
          {dataField: "reportSuppliedAt", caption: "Report"},
        ];
      
        let showAllColumnsMobile = [
          {dataField: "name", caption: "Name"},
          {dataField: "reportSuppliedAt", caption: "Report"}
        ];

        let SCOReceived = {dataField: "SCOReceived", caption: "Received From"}
        let SCOGiven =  {dataField: "SCOGiven", caption: "Given To"}

        let secondaryCoachText =<></>
        if(this.state.selected_UUIDs.length>1){
          secondaryCoachText =  <>these {this.state.selected_UUIDs.length} teams? After you do, the secondary</>
        }else{
          secondaryCoachText =  <>this team? After you do, the secondary</>
        }
        return (
          <main className="app-content">
                  <AephoriaTable
                  key={this.state.key}
                  route={`api/v2/coaches/${this.state.coachId}/teams`}
                  massageData = {this.massageData}
                  selectedData ={this.selectedData}
                  onSelectionChanged={this.onSelectionChanged}
                  filterButtons={utils.filterButtons.filter(button => ['allRecords', 'wrapped', 'unwrapped'].includes(button.id))}
                  deleteConfig={
                    {
                      endpoint: 'api/v2/teams',
                      pluralDisplayName: "Teams",
                      displayCallback: function(record) {
                        return(record.name)
                      },
                      checkForReportRequested:true
                    }
                  }
                  tableFunctions={[
                    ...(isMobile?[]:[{caption: 'Add Team', icon: addIcon, minRecordsRequired: 0, ourownonclick: this.handleAdd, frequentlyUsed: true}]),
                    ...(isMobile?[]:[{caption: 'View Team', icon: viewIcon, minRecordsRequired: 1, maxRecordsRequired: 1, ourownonclick: this.handleView, frequentlyUsed: true}]),
                    ...(isMobile?[]:[{caption: 'Duplicate Team', icon: copyIcon, minRecordsRequired: 1, maxRecordsRequired: 1, ourownonclick: this.openDuplicateModal, frequentlyUsed: true}]),
                  ...(isMobile?[]:[{caption: 'Add Team Members', icon:addIcon,tooltipText: `Adding team members can be done on the assessments page - there you can select some assessments and click 'Add to Team'. This button here will take you to the assessments page. Or, you can View Team, and then Add Members directly from the team page.`,minRecordsRequired: 1, maxRecordsRequired: 1,  ourownonclick:this.addTeamMembers,frequentlyUsed: true}]),
                    ...(isMobile?[]:[{caption: 'Download summary', icon: downloadIcon, minRecordsRequired: 1, maxRecordsRequired: 1, ourownonclick: this.downloadSummary, frequentlyUsed: true}]),
                    ...(isMobile?[]:[{caption: 'Assign SCO', icon: viewIcon, minRecordsRequired: 1, ourownonclick: this.openAssignSCOModal, frequentlyUsed: false}]),
                    ...(isMobile?[]:[{caption: 'Wrap/Unwrap', icon: <AssignmentTurnedInIcon />, minRecordsRequired: 1, ourownonclick: this.openWrapUpModal, frequentlyUsed: false}]),
                    ...(isMobile?[]:[{caption: 'Delete', icon: deleteIcon, minRecordsRequired: 1, frequentlyUsed: false}]),
                    ...(isMobile?[]:[{caption: 'Edit', icon: editIcon, minRecordsRequired: 1, maxRecordsRequired: 1, ourownonclick: this.handleEdit, frequentlyUsed: false}]),
                  ]}
                  tableName="Teams"
                  displayFields={[...(isMobile ? showAllColumnsMobile : showAllColumnsDesktop),
                    ...(!this.state.scoGivenToExist? [] : [SCOGiven]) ,
                    ...(!this.state.scoReceivedFromExist? [] : [SCOReceived])                  
                    ]} />
                  <Modal isOpen={this.state.modalIsOpen} onClose={() => this.closeModal()}>
                    <h3>{this.state.teamsModalTitle}</h3>
                    <span style={{fontSize:"10px"}}>A team is 3 or more people. If only 2 members we suggest <br/>you use our fit for purpose new Couples/Colleagues report.</span>
                    <div className="edit-div">
                      <div className={`input-wrapper-1 ${this.state.isReportAvailable ? 'disabled' : ''}`} >
                      <div className="tooltip-wrapper">

                        <input type="text" name="name" id="name" maxLength="250" onChange={this.handleChange} value={this.state.name} disabled={this.state.isReportAvailable} autoFocus/>
                        {this.state.isReportAvailable && (
                          <div className="tooltip-text">
                            Editing the team name is disabled when the report is available.
                          </div>
                        )}
                    </div>
                        <label className="edit" htmlFor ="name">Name</label>
                    </div>
                      <div className="input-wrapper-1">
                        <textarea rows="3" maxlength="250" cols="30" className="editTeamTextArea" name="description" id="description" onChange={this.handleChange} value={this.state.description} />
                        <label className="edit" htmlFor ="description" style={{"top":"30px"}}>Description</label>
                      </div>
                      <div className="input-wrapper-1">
                        <input type="text" name="projectName" id="projectName" maxLength="250" onChange={this.handleChange} value={this.state.projectName}/>
                        <label className="edit" htmlFor ="projectName">Project</label>
                      </div>
                    </div>
                    <Button variant="contained" color="primary" type="submit" onClick={this.state.teamsModalSubmitFunction}>{this.state.teamsModalSubmitCaption}</Button>
                  </Modal>
                  
                  <Modal isOpen={this.state.openModal} onClose={() => this.closeModal()}>
                    <h3>{this.state.teamsModalTitle}</h3>
                    <div check>
                          <input
                            type="radio"
                            value="Ennea"
                            checked={this.state.reportType === "Ennea"}
                            onChange={this.onChangeValue}
                          />
                          <span style={{ marginLeft: "5px" }}>Enneagram</span>
                    </div>
                    <div check>
                          <input
                            type="radio"
                            value="IMf"
                            disabled={!this.state.hasMaturityAccreditation}
                            checked={this.state.reportType === "IMf"}
                            onChange={this.onChangeValue}
                          />
                          <span style={{ marginLeft: "5px" }}>Maturity</span>
                    </div>
                    <div check>
                          <input
                            type="radio"
                            value="Full"
                            disabled={!this.state.hasMaturityAccreditation}
                            checked={this.state.reportType === "Full"}
                            onChange={this.onChangeValue}
                          />
                          <span style={{ marginLeft: "5px" }}>Combined</span>
                    </div>
                    <br></br>
                    <div>
                      <span>Due Date:</span><br></br>
                      <input type="date" id="date-picker" name="requestDate" min={this.state.minDate} onChange={this.changeDate}/>
                    </div>
                    <Button variant="contained" color="primary" type="submit" onClick={this.state.teamsModalSubmitFunction}>{this.state.teamsModalSubmitCaption}</Button>
                  </Modal>

                  <Modal isOpen={this.state.confirmationModal} onClose={() => this.closeModal()}>
                      <h3>{this.state.confirmationHeading}</h3>
                      {this.state.confirmationModalText}
                      <br/><br/>  
                      <Button variant="contained" color="primary" type="submit" onClick={()=>this.state.confirmationFunction(true)}>Ok</Button>
                      <Button variant="contained" color="primary" type="submit" onClick={()=>this.closeModal()}>Cancel</Button>
                  </Modal>

                {/* =========================Assigning SCO Modal=========================== */}

                <Modal isOpen={this.state.assignSCOModalOpen} onClose={() => this.closeModal()}>
                  <h2>Assign Secondary Ownership</h2>
                  <span>Enter Secondary Coach Email Address:</span>
                  <br></br>
                  <div className="input-wrapper-2">
                    <input className="input" type="email" name="secondaryCoachEmailAddress" id="secondaryCoachEmailAddress" maxLength="45" onChange={this.handleChange} value={this.state.secondaryCoachEmailAddress} style={{ "margin": "10px 0px", "padding": "8px 16px","minWidth":"100%"}} />
                    <label className="edit">Email</label>
                  </div>
                  <p style={{display:this.state.showInvalidEmailAddressText?"block":"none", color:"red"}}>Please enter a valid email address.</p>
                  <p>You will be assigning secondary coach ownership to this coach, for the {this.state.selectedAssessmentUUIDs.length} selected record(s).</p>
                  <p>Please take care when assigning SCO as you are sharing sensitive data that requires data protection to another party. If you do not yet have an agreement with the coach in question around use of sensitive personal information, please put this in place prior to assigning SCO rights.</p>
                  <p>You can revoke SCO at any time - on completion of a project or when sharing these teams is no longer necessary. You'll see the coaches' names with whom you have shared teams in the "Given To" column on the Teams table - click the trashcan icon shown after a coach name to revoke SCO for that coach.</p>
                  <Button variant="contained" color="primary" type="submit" disabled={this.state.invalidEmailAddress?true:false} onClick={() => this.assignTeamSCO()}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>

                <Modal isOpen={this.state.revokeSCOModal} onClose={() => this.closeModal()}>
                <h3>{this.state.revokeSCOModalTitle}</h3>
                <p>{this.state.revokeMessage}</p>
                  <Button variant="contained" color="primary" type="submit" onClick={this.state.revokeModalSubmitFunction}>Revoke</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button>
                </Modal>
                  
                  <Modal isOpen={this.state.duplicateModal} onClose={() => this.closeModal()}>
                    <h3>Duplicate {this.state.name}</h3>
                    <p>If you proceed, this team will be copied to a new team,
                      <br></br> with the same team members. You can then edit the new 
                      <br></br>team and add and remove members as usual, and 
                      <br></br>request a team report.
                    </p>
                    <div className="edit-div">
                      <div className="input-wrapper-1">
                        <input type="text" name="newTeamName" id="newTeamName"  maxLength="250" onChange={this.handleChange} value={this.state.newTeamName} autoFocus/>
                        <label className="edit" htmlFor ="name">New team name</label>
                      </div>
                    </div>                     
                    <Button variant="contained" color="primary" type="submit" onClick={()=>this.handleDuplicate()}>Duplicate</Button>
                    <Button variant="contained" color="primary" type="submit" onClick={()=>this.closeModal()}>Cancel</Button>
                  </Modal>

                  <Toast
                    level={this.state.level}
                    message={this.state.message}
                    visible={this.state.showToast}
                  />

                  <AlertModal
                    message={this.state.alertMessage}
                    modalTitle={this.state.alertModalTitle}
                    isOpen={this.state.openAlertModal}
                    showClose={() => this.closeModal()}
                  />
            <LoadingBackdrop open={this.state.openBackdrop} />
          </main>
        );
    }
}

export default withRouter(withStyles(styles)(Teams))
